import { render, staticRenderFns } from "./Instruction-add.vue?vue&type=template&id=4bc93eda&"
import script from "./Instruction-add.vue?vue&type=script&lang=js&"
export * from "./Instruction-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports